var TYPE = {
  SEARCH: 'search',
  AUTO_COMPLETE: 'autoComplete'
};
export default TYPE;
//# sourceMappingURL=constants.js.map
